import React from 'react';
import styles from './KpiCard.module.css';

export interface KpiCardProps {
  /**
   * Title of the KPI
   */
  title: string;
  /**
   * Value to be displayed
   */
  value: string | number;
  /**
   * Icon name from Material Symbols
   */
  icon: string;
  /**
   * Optional description text below the value
   */
  description?: string;
  /**
   * Trend visual indicator for the description
   */
  trend?: 'up' | 'down' | 'neutral' | 'warning';
  /**
   * Color variant for the icon background
   */
  variant?: 'success' | 'warning' | 'danger' | 'info' | 'primary';
  /**
   * Optional icon to display before the description
   */
  descriptionIcon?: string;
}

/**
 * KpiCard component to display key performance indicators.
 */
export const KpiCard: React.FC<KpiCardProps> = ({
  title,
  value,
  icon,
  description,
  trend = 'neutral',
  variant = 'primary',
  descriptionIcon,
}) => {
  return (
    <div className={`${styles.kpiCard} ${styles[`variant-${variant}`]}`}>
      <div className={styles.content}>
        <span className={styles.title}>{title}</span>
        <div className={styles.value}>{value}</div>
        {description && (
          <div className={`${styles.description} ${styles[`trend-${trend}`]}`}>
            {descriptionIcon && (
              <span className={`material-symbols-outlined ${styles.descriptionIcon}`}>
                {descriptionIcon}
              </span>
            )}
            {description}
          </div>
        )}
      </div>
      <div className={styles.iconWrapper}>
        <span className={`material-symbols-outlined ${styles.mainIcon}`}>{icon}</span>
      </div>
    </div>
  );
};

export default KpiCard;
